module.exports = __webpack_public_path__ + "img/xbsys4.477c62f2.png";